/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MSP08Dto { 
    saccosName?: string | null;
    mspcode?: string | null;
    computedLiquidAssets?: number | null;
    cashInHand?: number | null;
    currentAccountsAmount?: number | null;
    accountsReceivableAmount?: number | null;
    governmentSecuritiesAmount?: number | null;
    investmentsAmount?: number | null;
    moneyNetworksAmount?: number | null;
    agentBankingAccountAmount?: number | null;
    otherLiquidAssetAmount?: number | null;
    totalAvailableLiquidAssets?: number | null;
    totalSavingsAndDepositsAmount?: number | null;
    accountsPayableAmount?: number | null;
    shortTermBorrowingSACCOsAmount?: number | null;
    shortTermBorrowingBanksAmount?: number | null;
    totalShortTermLiabilitiesAmount?: number | null;
    totalRequiredMinimumLiquidAssets?: number | null;
    totalLiquidAssetsAmount?: number | null;
    minimumLiquidityRatioRegulation?: number | null;
    minimumLiquidityRationPEARLS?: number | null;
}

